import { getFormatter, SingleMetricChart } from '@revelio/replots';

import { useCurrencyPreference } from '../../../../shared/user-preferences/hooks/useCurrencyPreference';
import type { SingleDataSet } from '../DataProvider/types';
import type { MetricValues } from '../PageConfigProvider/types/metric';
import { getFormat } from './utils/getFormat';

export const Metric = ({
  data,
  metric,
}: {
  data: SingleDataSet['data'];
  metric?: MetricValues;
}) => {
  const { code } = useCurrencyPreference();
  const format = getFormat({ metric });
  const formatValue = getFormatter(format, { currencyCode: code });

  const value = data.length > 0 ? (data[0]?.value ?? null) : null;
  const formatted =
    value !== null && value !== undefined ? formatValue(value) : '—';

  return <SingleMetricChart value={formatted} />;
};
